import React, { useContext, useEffect, useRef, useState } from "react";
import "../../Styles/XDOCKSearch.scss";
import BlockUi from '@availity/block-ui';
import {Circles} from "react-loader-spinner";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import * as tmServices from "../../Services/ComponentBasedServices/xDockSearchService";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import constants from "../../../common/restService/constant";
import GatewayGet from "../../../common/restService/GatewayGet";

import { GetUserDetails } from "../../Services/CommonServices/GetUserDetailsService";
import { read } from "xlsx";
import { BulkUploadData } from "../../Services/ComponentBasedServices/xDockReportService";


const XDOCKMassUpload = (props) => {
  //Hooks declaration
  const [block, setBlock] = useState(false);
  const [data, setData] = useState([]);
  const [SCACTextValue, setSCACTextValue] = useState("");
  const [inputValues, setInputValues] = useState({
    carrier: "",
  });
  const [ParentScac, setParentScac] = useState({ text: "Select SCAC" });

  const carrier = useRef();
  const hawbFrom = useRef();
  const disableScac = useRef(false);
  const [userDetails, setUserDetails] = useState(null);

  // File upload States
  const [selectedFile, setSelectedFile] = React.useState("");
  const [fileData, setFileData] = React.useState("");
  const [base64Data, setBase64Data] = React.useState("");

  useEffect(() => {
    async function getUserDetails() {
      setBlock(true);
      let { RESULT } = await GetUserDetails();
      setBlock(false);
      setUserDetails(RESULT);
    }

    getUserDetails();
  }, []);

  useEffect(() => {
    if (userDetails !== null) {
      getSCACDataFromService();
      carrier.current.focus();
      if (userDetails.STATUS === "SUCCESS") {
        var roleList = userDetails.RESULT["ROLE_LIST"];
        if (roleList["CARRIER"] === "True") {
          var Scac = getParentSCAC(userDetails.RESULT["CARRIER_SCAC"]);
          setParentScac({ text: Scac });
        }
      }
    }
  }, [userDetails]);

  useEffect(() => {
    async function getUserData() {
      let { RESULT } = await GetUserDetails();

      if (RESULT["IS_EXTUSER"] !== "No" && RESULT["CARRIER_ID"] !== "") {
        disableScac.current = true;

        if (
          data.filter(
            (ele) => ele["value"].split(" ")[0] === RESULT["CARRIER_ID"]
          )[0] === undefined
        )
          return;
        var Scac = getParentSCAC(
          data.filter(
            (ele) => ele["value"].split(" ")[0] === RESULT["CARRIER_ID"]
          )[0]["text"]
        );
        setParentScac(
          data.filter(
            (ele) => ele["value"].split(" ")[0] === RESULT["CARRIER_ID"]
          )[0]
        );
        setInputValues({ ...inputValues, carrier: Scac });
      }
    }
    getUserData();
  }, [data]);

  //API Calls
  const getSCACDataFromService = async () => {
    const response = await tmServices.GetSCACData();
    setData(response);
  };

  //Generic Functions

  function getParentSCAC(dd) {
    var c_code = "";
    var descPartss = "";
    for (var i = 0; i < data.length; i++) {
      if (data[i].text === dd) {
        var descParts = data[i].text;
        descPartss = data[i].value;
        c_code = descParts;
      }
    }

    setSCACTextValue(descPartss);

    return c_code;
  }

  //Handler Events
  const handleSCACChange = (e) => {
    setParentScac({ text: e.target.value.text });
    setSCACTextValue(e.target.value.value);
    setInputValues({ ...inputValues, carrier: e.target.value.text });
  };

  const txtKeyUpEvent = (e, value) => {
    if (e.key === "Enter") {
      if (value === "carrierdp") {
        hawbFrom.current.focus();
      }
    }
  };

  const uploadFile = () => {
    if (!ParentScac.text || ParentScac.text == "Select SCAC") {
      toast.error("Please select SCAC");
      return;
    }
    if (!selectedFile) {
      toast.error("Please select File");
      return;
    }
    var workbook = read(fileData, {
      type: "binary",
    });

    let fullFileName = selectedFile.split(".");
    let extension = fullFileName[fullFileName.length - 1];
    if (extension != "xlsx" && extension != "xls") {
      toast.error("Accepts only Excel file");
      return;
    }
    
    var inputObj = {
      filename: selectedFile,
      content: base64Data,
      SCAC: ParentScac.text,
    };
    uploadExcel(inputObj);
  };

  const uploadExcel = async (input) => {
    setBlock(true);
    const response = await BulkUploadData(input);
    setBlock(false);

    let typeError = false;
    let typeErrorMessage = "";
    response.forEach((data) => {
      if (data["TYPE"] === "E") {
        typeError = true;
        typeErrorMessage = data["MESSAGE"];
      }
    });

    if (typeError === true) {
      toast.error(typeErrorMessage);
    }

    if (typeError === false) {
      toast.success("File uploaded successfully");
    }
  };

  const onFileChange = (event) => {
    var uploadedFile = event.target.files[0];
    var filename = uploadedFile.name;
    setSelectedFile(filename);

    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      var Filedata = "";
      var bytes = new Uint8Array(reader.result);
      for (var i = 0; i < bytes.byteLength; i++) {
        Filedata += String.fromCharCode(bytes[i]);
      }
      var base64Data = window.btoa(Filedata);
      setFileData(Filedata);
      setBase64Data(base64Data);
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <>
      <div id="xdockSearch" className="xDockSearch">
      <BlockUi
          tag="div"
          blocking={block}
          loader={
            <Circles
                  color="#00BFFF"
                  height="100"
                  width="100"
                  timeout="6000" //3 secs
                />
          }
        >
      
          <>
            <div>
              <MDBContainer fluid>
                <MDBRow>
                  <MDBCol sm="12" className="titleBox">
                    <label>CROSS DOCK ETA </label>
                  </MDBCol>
                </MDBRow>
              </MDBContainer>
            </div>

            <MDBContainer fluid className="xDockSearch-Inputs">
              <h6 className="titleFG">Cross Dock ETA Mass Upload</h6>
              <br />
              <br />
              {/* SCAC */}
              <MDBRow>
                <MDBCol md="2">
                  <label style={{ padding: "15px" }}>
                    SCAC <em>*</em>
                  </label>
                </MDBCol>
                <MDBCol md="3">
                  <DropDownList
                    style={{ width: "100px" }}
                    data={data}
                    dataItemKey={"text"}
                    textField={"text"}
                    className="k-input k-textbox"
                    onChange={handleSCACChange}
                    ref={carrier}
                    onKeyPress={txtKeyUpEvent("carrierdp")}
                    value={ParentScac}
                    disabled={disableScac.current}
                  />
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="text"
                    disabled={true}
                    value={SCACTextValue}
                    className="form-control FGtxt SCACInput"
                    style={{ width: "250px" }}
                  />
                </MDBCol>
                <MDBCol md="3"></MDBCol>
              </MDBRow>
              <br />
              <MDBRow>
                <br></br>
                <MDBCol md="2">
                  <label style={{ padding: "15px" }}>
                    File <em>*</em>
                  </label>
                </MDBCol>
                <MDBCol md="4">
                  {/* ------------ UPLOAD ------------ */}
                  <>
                    <div class="fileSection">
                      <input
                        type="file"
                        id="massFileUpload"
                        onChange={onFileChange}
                      ></input>
                      <button
                        className="k-button k-button-md k-rounded-md k-button-solid f-32"
                        onClick={uploadFile}
                      >
                        Upload
                      </button>
                    </div>
                  </>
                </MDBCol>
                {/* ------------ UPLOAD ------------*/}
              </MDBRow>
              <br /> <br /> <br /> <br /> <br /> <br /> <br /> 
            </MDBContainer>
          </>
        </BlockUi>
      </div>
    </>
  );
};

export default XDOCKMassUpload;
